import React, { useMemo } from 'react';
import { FaCheck } from 'react-icons/fa';

import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

import { AnswerValues } from './PublicSurveyContainer';

interface PublicYesNoTextQuestionProps {
  value: AnswerValues;
  onChange: (value: AnswerValues) => void;
  currentLanguage: string;
}

export const PublicYesNoTextQuestion: React.FC<
  PublicYesNoTextQuestionProps
> = ({ value, onChange, currentLanguage }) => {
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);
  const maxLength = 1800;
  const currentLength = value?.textValue?.length || 0;

  const parsedValue = useMemo(() => {
    return {
      yesNo: value.booleanValue,
      comment: value.textValue || '',
    };
  }, [value]);

  const handleYesNoChange = (newYesNo: boolean) => {
    const newValue = parsedValue.comment
      ? { booleanValue: newYesNo, textValue: parsedValue.comment }
      : { booleanValue: newYesNo };
    onChange(newValue);
  };

  const handleCommentChange = (newComment: string) => {
    const newValue =
      parsedValue.yesNo !== undefined
        ? { booleanValue: parsedValue.yesNo === true, textValue: newComment }
        : { textValue: newComment };
    onChange(newValue);
  };

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex flex-column gap-3">
        <button
          type="button"
          onClick={() => handleYesNoChange(true)}
          className={`public-survey-radio-option ${parsedValue.yesNo === true ? 'selected' : ''}`}
        >
          <div
            className={`public-survey-radio-indicator ${parsedValue.yesNo === true ? 'selected' : ''}`}
          >
            {parsedValue.yesNo === true && <FaCheck color="white" size={12} />}
          </div>
          <span className="public-survey-radio-label">
            {t(tk.publicSurvey.yes)}
          </span>
        </button>

        <button
          type="button"
          onClick={() => handleYesNoChange(false)}
          className={`public-survey-radio-option ${parsedValue.yesNo === false ? 'selected' : ''}`}
        >
          <div
            className={`public-survey-radio-indicator ${parsedValue.yesNo === false ? 'selected' : ''}`}
          >
            {parsedValue.yesNo === false && <FaCheck color="white" size={12} />}
          </div>
          <span className="public-survey-radio-label">
            {t(tk.publicSurvey.no)}
          </span>
        </button>
      </div>

      <div className="public-survey-animate-slide-up">
        <label className="public-survey-comment-label" htmlFor="yesno-comment">
          {t(tk.publicSurvey.commentOptional)}
        </label>
        <textarea
          id="yesno-comment"
          value={parsedValue.comment}
          onChange={e => handleCommentChange(e.target.value)}
          placeholder={t(tk.publicSurvey.addComment)}
          className="public-survey-textarea"
          style={{ minHeight: '120px' }}
          maxLength={maxLength}
        />
        <div className="text-muted small text-end mt-1">
          {currentLength} / {maxLength}
        </div>
      </div>
    </div>
  );
};
